import { CenterDiv } from "components/CenterDiv"

export const AccessDenied = () => {
  return (
    <CenterDiv>
      <h1>Acesso não permitido</h1>
    </CenterDiv>
  )
}
